export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  category: string;
  year: number;
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  tags: string[];
  coverImage: string;
  bannerImage: string;
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
}

export const movies: Movie[] = [
  {
    id: 'movie-001',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    category: '电影',
    year: 2026,
    rating: 9.2,
    description: '太阳急速老化，地球再次面临毁灭危机，人类联合政府启动移山计划最终阶段，一场关乎文明存亡的壮丽征程再度开启。',
    longDescription: '在《流浪地球3》中，太阳急速老化膨胀，地球面临着被吞没的危机。人类联合政府启动了庞大的移山计划，建造上万座行星发动机推动地球逃离太阳系。然而前方路途充满未知危险，木星引力危机、小行星带穿越、以及人类内部的分歧，都让这场长达2500年的流浪之旅充满变数。刘培强等航天员再次挺身而出，在浩瀚宇宙中谱写了一曲人类命运共同体的壮歌。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    duration: '148分钟',
    tags: ['科幻', '灾难', '冒险', '国产大片'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20featuring%20astronaut%20in%20space%20suit%20with%20giant%20planet%20engines%20glowing%20orange%20against%20dark%20cosmic%20background%2C%20epic%20cinematic%20lighting%2C%20dramatic%20composition%2C%20movie%20poster%20design%20with%20Chinese%20typography%2C%20warm%20golden%20and%20cosmic%20tones%2C%20high%20contrast&width=600&height=900&seq=movie-cover-001&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20massive%20planetary%20engines%20firing%20on%20frozen%20Earth%20surface%2C%20dramatic%20orange%20glow%20against%20dark%20space%2C%20grand%20scale%20landscape%2C%20cinematic%20widescreen%20composition%2C%20atmospheric%20fog%20and%20ice%20crystals%2C%20heroic%20silhouette%20in%20foreground%2C%20warm%20golden%20light%20contrasting%20with%20cold%20tones&width=1920&height=800&seq=movie-banner-001&orientation=landscape',
    isHot: true,
    isNew: false,
    updateInfo: '更新至HD高清',
  },
  {
    id: 'movie-002',
    title: '繁花似锦',
    englishTitle: 'Blooming Flowers',
    category: '电视剧',
    year: 2026,
    rating: 8.9,
    description: '九十年代上海，一群年轻人在改革开放浪潮中追逐梦想，爱情与事业交织，演绎了一段令人动容的时代故事。',
    longDescription: '《繁花似锦》以1990年代的上海为背景，讲述了阿宝、沪生、小毛等年轻人在中国改革开放的大时代中奋斗成长的故事。从弄堂到陆家嘴，从纺织厂到证券交易所，他们在时代的洪流中寻找自己的位置。阿宝凭借敏锐的商业嗅觉白手起家，沪生在金融界打拼，小毛则坚守着传统手艺的传承。三条人生轨迹交织缠绕，既有商海沉浮的惊心动魄，也有平凡生活的温情脉脉。这不仅是一部都市情感剧，更是一幅九十年代中国社会变革的鲜活画卷。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    region: '中国大陆',
    duration: '40集/45分钟',
    tags: ['都市', '情感', '年代', '商战'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20couple%20in%20vintage%20fashion%20with%20city%20skyline%20background%2C%20warm%20nostalgic%20golden%20lighting%2C%20film%20grain%20texture%2C%20romantic%20cinematic%20atmosphere%2C%20retro%20Chinese%20aesthetic%2C%20soft%20bokeh%20neon%20lights&width=600&height=900&seq=movie-cover-002&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20cityscape%20at%20dusk%2C%20traditional%20lane%20houses%20and%20modern%20skyscrapers%20contrast%2C%20warm%20golden%20hour%20light%2C%20neon%20signs%20reflecting%20on%20wet%20streets%2C%20people%20walking%20in%20period%20clothing%2C%20cinematic%20widescreen%2C%20romantic%20nostalgic%20mood%2C%20soft%20film-like%20color%20grading&width=1920&height=800&seq=movie-banner-002&orientation=landscape',
    isHot: true,
    isNew: true,
    updateInfo: '更新至第28集',
  },
  {
    id: 'movie-003',
    title: '荒野猎杀',
    englishTitle: 'Wild Hunt',
    category: '电影',
    year: 2026,
    rating: 8.7,
    description: '退役特种兵在原始森林中保护珍稀动物，与跨国盗猎集团展开一场生死较量，人性与野性的终极博弈。',
    longDescription: '曾在特种部队服役的林峰退役后成为了一名护林员，在西南边陲的原始森林中守护着濒危动物。一天，一支装备精良的跨国盗猎集团闯入保护区，他们的目标是捕获稀有金丝猴。林峰独自一人与盗猎者在密林中展开了一场惊心动魄的追捕与反追捕。在这场力量悬殊的对抗中，他不仅要面对凶残的敌人，还要与恶劣的自然环境抗争。这是一部融合了动作、悬疑与环保主题的硬核电影，展现了人与自然之间复杂而深刻的关系。',
    director: '林超贤',
    actors: ['张译', '段奕宏', '王景春', '李现'],
    region: '中国大陆',
    duration: '135分钟',
    tags: ['动作', '冒险', '犯罪', '环保'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20action%20thriller%20movie%20poster%2C%20soldier%20in%20camouflage%20holding%20rifle%20in%20dense%20bamboo%20forest%2C%20intense%20expression%2C%20dramatic%20rain%20and%20fog%20atmosphere%2C%20dark%20moody%20green%20tones%2C%20cinematic%20lighting%20with%20god%20rays%2C%20action%20movie%20poster%20design&width=600&height=900&seq=movie-cover-003&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dense%20bamboo%20forest%20in%20misty%20rain%2C%20dramatic%20atmospheric%20fog%2C%20mysterious%20green%20tone%2C%20sunlight%20breaking%20through%20canopy%2C%20cinematic%20widescreen%20nature%20landscape%2C%20action%20thriller%20mood%2C%20dark%20moody%20aesthetic%2C%20rain%20drops%20on%20leaves&width=1920&height=800&seq=movie-banner-003&orientation=landscape',
    isHot: false,
    isNew: true,
    updateInfo: 'HD高清',
  },
  {
    id: 'movie-004',
    title: '星光大道·巅峰对决',
    englishTitle: 'Star Avenue Final',
    category: '综艺',
    year: 2026,
    rating: 8.5,
    description: '全国顶级综艺选秀节目总决赛，十二位实力唱将同台竞技，争夺年度总冠军的终极荣耀。',
    longDescription: '《星光大道·巅峰对决》是年度最受瞩目的音乐竞技综艺节目。经过全国海选和层层淘汰，十二位风格迥异的实力唱将脱颖而出，站上了总决赛的舞台。节目采用全新赛制，包括经典重现、跨界挑战、原创对决等多个环节。每一位选手都带来了令人震撼的表演，从民族唱法到流行摇滚，从戏曲改编到国际金曲，展现了华语音乐的多元魅力。导师阵容豪华，包括了那英、周杰伦、刘欢等华语乐坛顶级音乐人。这是一场音乐的盛宴，也是对梦想的致敬。',
    director: '洪涛',
    actors: ['那英', '周杰伦', '刘欢', '邓紫棋', '周深'],
    region: '中国大陆',
    duration: '12期/120分钟',
    tags: ['音乐', '竞技', '选秀', '综艺'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%2C%20glamorous%20stage%20with%20spotlights%20and%20confetti%2C%20singer%20with%20microphone%20in%20elegant%20outfit%2C%20grand%20theater%20setting%2C%20dramatic%20stage%20lighting%20in%20gold%20and%20warm%20tones%2C%20celebratory%20atmosphere%2C%20concert%20poster%20design&width=600&height=900&seq=movie-cover-004&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20magnificent%20lighting%20design%2C%20golden%20spotlights%20beaming%20from%20ceiling%2C%20large%20LED%20screen%20displaying%20visuals%2C%20professional%20band%20setup%2C%20dramatic%20theater%20atmosphere%2C%20warm%20golden%20and%20amber%20lighting%2C%20grandiose%20venue%2C%20cinematic%20widescreen&width=1920&height=800&seq=movie-banner-004&orientation=landscape',
    isHot: true,
    isNew: false,
    updateInfo: '更新至第10期',
  },
  {
    id: 'movie-005',
    title: '灵笼·终章',
    englishTitle: 'Ling Cage Final',
    category: '动漫',
    year: 2026,
    rating: 9.4,
    description: '末日废土世界中，人类在浮空堡垒灯塔上艰难求生，地面小队为寻找希望深入充满噬极兽的死亡禁区。',
    longDescription: '《灵笼·终章》是国产科幻动画的巅峰之作。故事设定在世界末日后的废土时代，幸存的人类生活在悬浮于天空的巨大堡垒灯塔之上。地面上遍布着可怕的噬极兽，任何接触都可能导致死亡或变异。猎荒者小队作为人类最后的希望，奉命深入地面禁区执行危险任务。在这一季终章中，马克队长带领团队揭开了噬极兽背后的惊人真相，也发现了关于人类文明覆灭的终极秘密。精良的3D制作、深刻的世界观和扣人心弦的剧情，让这部作品成为国漫里程碑。',
    director: '董相博',
    actors: ['黄莺', '李元韬', '陶典', '程玉珠'],
    region: '中国大陆',
    duration: '16集/30分钟',
    tags: ['科幻', '末日', '机甲', '国漫'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%2C%20futuristic%20soldier%20in%20mechanical%20armor%20with%20energy%20weapon%2C%20post-apocalyptic%20wasteland%20background%2C%20floating%20city%20in%20sky%2C%20dark%20atmospheric%20lighting%2C%20sci-fi%20concept%20art%20style%2C%20dramatic%20composition%2C%20orange%20and%20teal%20color%20scheme&width=600&height=900&seq=movie-cover-005&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20wasteland%20with%20floating%20mechanical%20city%20in%20dramatic%20sky%2C%20destroyed%20urban%20landscape%20below%2C%20epic%20scale%2C%20atmospheric%20fog%20and%20dust%2C%20sci-fi%20concept%20art%2C%20dark%20moody%20tones%20with%20orange%20accents%2C%20cinematic%20widescreen%20composition&width=1920&height=800&seq=movie-banner-005&orientation=landscape',
    isHot: false,
    isNew: false,
    updateInfo: '全16集',
  },
  {
    id: 'movie-006',
    title: '风味人间·第五季',
    englishTitle: 'Once Upon a Bite S5',
    category: '纪录片',
    year: 2026,
    rating: 9.6,
    description: '舌尖团队全新力作，跨越五大洲探寻人类与食物之间最动人的故事，每一帧都是视觉与味觉的双重盛宴。',
    longDescription: '《风味人间·第五季》由陈晓卿导演带领的舌尖原班人马倾力打造。这一季的视野更加宏大，摄制组跨越亚洲、欧洲、非洲、美洲和大洋洲，深入探访了50多个国家和地区的美食文化。从日本北海道的深海渔获到摩洛哥的香料市场，从意大利的百年奶酪工坊到秘鲁的安第斯山脉土豆田，每一集都是对一种食材或一种烹饪方式的深度探索。采用超高速摄影和微距镜头，将食物的变化过程拍成了流动的艺术。这不仅仅是一部美食纪录片，更是一部关于人类文明、自然与文化的宏伟史诗。',
    director: '陈晓卿',
    actors: ['李立宏'],
    region: '中国大陆',
    duration: '8集/50分钟',
    tags: ['美食', '文化', '旅行', '人文'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20beautifully%20plated%20traditional%20Chinese%20dish%20with%20steam%20rising%2C%20dark%20moody%20background%2C%20warm%20golden%20lighting%20on%20food%2C%20elegant%20food%20photography%2C%20cultural%20elements%20in%20background%2C%20cinematic%20food%20styling%2C%20rich%20textures%20and%20colors&width=600&height=900&seq=movie-cover-006&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20traditional%20Chinese%20market%20with%20colorful%20fresh%20produce%20and%20steaming%20food%20stalls%2C%20morning%20golden%20light%2C%20bustling%20atmosphere%2C%20cultural%20richness%2C%20mountains%20in%20background%2C%20cinematic%20widescreen%2C%20warm%20inviting%20tones%2C%20documentary%20style&width=1920&height=800&seq=movie-banner-006&orientation=landscape',
    isHot: false,
    isNew: true,
    updateInfo: '更新至第5集',
  },
  {
    id: 'movie-007',
    title: '深海迷城',
    englishTitle: 'Deep Sea Mystery',
    category: '电影',
    year: 2026,
    rating: 8.3,
    description: '一支海洋科考队在水下三千米发现神秘古城遗址，古老的秘密与未知的危险同时浮出水面。',
    longDescription: '在太平洋马里亚纳海沟附近，一支国际联合海洋科考队在进行深海探测时，意外发现了一处疑似远古文明的水下建筑群。地质学家苏晴带领团队乘坐最先进的深潜器深入三千米的海底，发现这些建筑的历史远超已知的任何人类文明。随着调查的深入，诡异的事件接连发生——设备无故失灵，队员出现幻觉，海底似乎有什么东西在注视着他们。当一座巨大的水下金字塔出现在视野中时，所有人都意识到，他们触碰到了不该触碰的东西。',
    director: '路阳',
    actors: ['杨幂', '朱一龙', '王传君', '张子枫'],
    region: '中国大陆',
    duration: '142分钟',
    tags: ['科幻', '悬疑', '冒险', '惊悚'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20underwater%20sci-fi%20movie%20poster%2C%20diver%20in%20deep%20sea%20with%20ancient%20ruins%20visible%20below%2C%20mysterious%20yellow%20glow%20from%20depths%2C%20dark%20ocean%20water%2C%20suspenseful%20atmosphere%2C%20dramatic%20lighting%20from%20above%2C%20cinematic%20movie%20poster%20design&width=600&height=900&seq=movie-cover-007&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20trench%20with%20ancient%20underwater%20pyramid%20structure%20partially%20illuminated%2C%20mysterious%20bioluminescence%2C%20dark%20water%20with%20light%20rays%20from%20surface%2C%20eerie%20atmosphere%2C%20cinematic%20widescreen%2C%20deep%20sea%20exploration%20mood&width=1920&height=800&seq=movie-banner-007&orientation=landscape',
    isHot: false,
    isNew: true,
    updateInfo: 'HD高清',
  },
  {
    id: 'movie-008',
    title: '长安十二时辰·续',
    englishTitle: 'The Longest Day in Chang\'an 2',
    category: '电视剧',
    year: 2026,
    rating: 9.0,
    description: '天宝三年上元节，长安城再起风云，靖安司李必与死囚张小敬携手破局，揭开一场危及大唐国运的惊天阴谋。',
    longDescription: '《长安十二时辰·续》延续了第一季的高水准制作。故事发生在安史之乱前夕，长安城中暗流涌动。靖安司司丞李必察觉到朝堂内外有一股神秘势力正在悄然布局，意图在上元节之夜发动致命一击。他再次请出曾与他并肩作战的张小敬，两人必须在十二个时辰之内找出幕后黑手。从东西市的繁华街巷到皇城深处的幽暗角落，从胡商聚集的坊市到戒备森严的大理寺，一场关乎大唐命运的时间赛跑就此展开。本剧服化道精良考究，真实还原了盛唐气象。',
    director: '曹盾',
    actors: ['易烊千玺', '雷佳音', '周一围', '热依扎'],
    region: '中国大陆',
    duration: '48集/45分钟',
    tags: ['古装', '悬疑', '历史', '权谋'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20Tang%20Dynasty%20official%20in%20traditional%20robe%20with%20ancient%20city%20at%20night%2C%20lanterns%20and%20fire%20in%20background%2C%20dramatic%20cinematic%20lighting%2C%20epic%20composition%2C%20warm%20fire%20glow%20contrasting%20with%20dark%20night%2C%20historical%20epic%20style&width=600&height=900&seq=movie-cover-008&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Chinese%20capital%20city%20at%20night%20during%20lantern%20festival%2C%20thousands%20of%20red%20lanterns%20illuminating%20traditional%20architecture%2C%20bustling%20streets%20with%20period%20costumes%2C%20grand%20palace%20in%20distance%2C%20cinematic%20widescreen%2C%20warm%20golden%20glow%2C%20epic%20historical%20atmosphere&width=1920&height=800&seq=movie-banner-008&orientation=landscape',
    isHot: true,
    isNew: false,
    updateInfo: '全48集',
  },
  {
    id: 'movie-009',
    title: '笑傲江湖·新生',
    englishTitle: 'Laughing in the Wind Reborn',
    category: '综艺',
    year: 2026,
    rating: 8.1,
    description: '全新喜剧竞演节目，十六组喜剧人通过素描喜剧、漫才、默剧等多种形式，为观众带来前所未有的欢乐体验。',
    longDescription: '《笑傲江湖·新生》是东方卫视推出的大型喜剧竞演综艺。节目汇集了来自全国各地的十六组喜剧人，包括资深喜剧演员、新生代脱口秀演员、相声新秀以及跨界表演者。每一期节目中，选手们需要围绕特定主题进行创作和表演，涵盖素描喜剧、漫才、即兴喜剧、默剧、音乐喜剧等多种形式。评委由沈腾、徐峥、贾玲、李诞四位喜剧大咖组成，他们不仅负责点评打分，还会亲自上台与选手互动切磋。这档节目打破了传统喜剧综艺的框架，展现了当代中国喜剧的多元面貌和蓬勃生命力。',
    director: '施嘉宁',
    actors: ['沈腾', '徐峥', '贾玲', '李诞'],
    region: '中国大陆',
    duration: '10期/100分钟',
    tags: ['喜剧', '竞技', '脱口秀', '综艺'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20show%20poster%2C%20comedian%20with%20exaggerated%20expression%20on%20colorful%20stage%2C%20bright%20vibrant%20lighting%2C%20confetti%20and%20laughter%2C%20fun%20playful%20atmosphere%2C%20variety%20show%20style%2C%20bold%20typography%2C%20energetic%20composition&width=600&height=900&seq=movie-cover-009&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Colorful%20comedy%20theater%20stage%20with%20vibrant%20set%20design%2C%20bright%20colorful%20lights%2C%20comedic%20atmosphere%2C%20audience%20laughter%20and%20applause%2C%20warm%20entertaining%20mood%2C%20variety%20show%20production%2C%20dynamic%20stage%20composition%2C%20cinematic%20widescreen&width=1920&height=800&seq=movie-banner-009&orientation=landscape',
    isHot: false,
    isNew: false,
    updateInfo: '更新至第7期',
  },
  {
    id: 'movie-010',
    title: '镇魂街·第四季',
    englishTitle: 'Rakshasa Street S4',
    category: '动漫',
    year: 2026,
    rating: 9.1,
    description: '曹焱兵觉醒全新守护灵，罗刹街的终极之战一触即发，人灵共存的命运将在此刻改写。',
    longDescription: '《镇魂街·第四季》延续了这部国漫经典的热血风格。在灵域的深处，曹焱兵终于觉醒了第七位守护灵，实力达到了前所未有的高度。然而，新的敌人也随之出现——来自远古的邪恶势力试图打破人界与灵域的平衡，将整个世界拖入无尽的黑暗。曹焱兵必须联合所有镇魂将，在罗刹街展开最后的决战。第四季在动作场面、剧情深度和情感刻画上都达到了系列巅峰，尤其是对守护灵与寄灵人之间羁绊的描绘令人动容。精良的2D手绘与3D特效的完美结合，让每一场战斗都震撼人心。',
    director: '卢恒宇',
    actors: ['夏磊', '谢添天', '冯骏骅', '沈达威'],
    region: '中国大陆',
    duration: '24集/22分钟',
    tags: ['热血', '战斗', '奇幻', '国漫'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%2C%20young%20warrior%20with%20flaming%20spirit%20guardian%20behind%2C%20ancient%20Chinese%20street%20setting%2C%20dynamic%20action%20pose%2C%20fire%20effects%2C%20dark%20night%20background%2C%20intense%20colors%2C%20anime%20style%20illustration&width=600&height=900&seq=movie-cover-010&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20street%20at%20night%20with%20supernatural%20energy%20and%20flames%2C%20traditional%20architecture%20contrasted%20with%20mystical%20elements%2C%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20warm%20fire%20glow%2C%20dynamic%20composition%2C%20cinematic%20widescreen&width=1920&height=800&seq=movie-banner-010&orientation=landscape',
    isHot: false,
    isNew: false,
    updateInfo: '更新至第18集',
  },
  {
    id: 'movie-011',
    title: '人类消失后的世界',
    englishTitle: 'World After Humans',
    category: '纪录片',
    year: 2026,
    rating: 9.3,
    description: '假如人类突然消失，地球会发生什么？本片通过惊人的CGI技术和科学推演，展现一个没有人类的地球。',
    longDescription: '《人类消失后的世界》是一部令人震撼的科幻纪录片。它提出了一个大胆的假设：如果人类在一瞬间全部消失，地球将经历怎样的变化？影片运用先进的CGI技术和严谨的科学推演，从人类消失的第一天开始，逐年展示地球的惊人变迁。核电站会因为无人维护而熔毁，城市将在几十年内被植被吞噬，野生动物重新占据曾经的人类领地，而塑料污染则需要数万年才能自然降解。更令人深思的是，影片还探讨了人类文明留下的痕迹——哪些能够穿越时间的长河，哪些将永远消失。',
    director: '陆川',
    actors: ['刘烨'],
    region: '中国大陆',
    duration: '6集/55分钟',
    tags: ['科幻', '自然', '科普', '人文'],
    coverImage: 'https://readdy.ai/api/search-image?query=Documentary%20poster%20showing%20abandoned%20city%20overtaken%20by%20nature%2C%20buildings%20covered%20in%20vines%20and%20moss%2C%20wildlife%20roaming%20streets%2C%20dramatic%20sky%2C%20post-apocalyptic%20beauty%2C%20green%20reclaiming%20urban%2C%20cinematic%20documentary%20style%2C%20thought-provoking%20atmosphere&width=600&height=900&seq=movie-cover-011&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Abandoned%20modern%20city%20overtaken%20by%20lush%20vegetation%2C%20skyscrapers%20covered%20in%20vines%2C%20deer%20and%20birds%20in%20empty%20streets%2C%20dramatic%20sunset%20light%2C%20nature%20reclaiming%20civilization%2C%20cinematic%20widescreen%2C%20beautiful%20post-apocalyptic%20scene&width=1920&height=800&seq=movie-banner-011&orientation=landscape',
    isHot: false,
    isNew: false,
    updateInfo: '全6集',
  },
  {
    id: 'movie-012',
    title: '剑来',
    englishTitle: 'Sword Comes',
    category: '动漫',
    year: 2026,
    rating: 9.5,
    description: '平凡少年陈平安手握一把普通铁剑，踏上修仙之路，在尔虞我诈的修真世界中坚守本心，一剑破万法。',
    longDescription: '《剑来》改编自烽火戏诸侯同名小说。故事讲述了泥瓶巷的贫苦少年陈平安，因缘际会之下踏入了波澜壮阔的修真世界。他没有显赫的家世，没有逆天的天赋，有的只是一把看似普通的铁剑和一颗赤诚之心。在北俱芦洲、浩然天下、青冥天下的宏大舞台上，陈平安以一个凡人之姿，经历了无数生死考验和人情冷暖。他不靠奇遇开挂，而是凭借着过人的智慧和坚韧不拔的意志，一步步从泥瓶巷走到诸天之巅。作品以其深厚的人文底蕴、严谨的修炼体系和精彩的人物塑造，被誉为国漫新标杆。',
    director: '赵霁',
    actors: ['杨天翔', '季冠霖', '乔诗语', '边江'],
    region: '中国大陆',
    duration: '26集/25分钟',
    tags: ['修仙', '玄幻', '热血', '国漫'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%2C%20young%20swordsman%20in%20traditional%20robe%20holding%20sword%2C%20floating%20mountains%20and%20clouds%20in%20background%2C%20mystical%20energy%20effects%2C%20Chinese%20ink%20painting%20style%2C%20elegant%20composition%2C%20warm%20golden%20light%2C%20fantasy%20art&width=600&height=900&seq=movie-cover-012&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20landscape%20with%20floating%20mountain%20peaks%20in%20clouds%2C%20ancient%20temples%20on%20cliffs%2C%20waterfall%20flowing%20into%20mist%2C%20golden%20sunlight%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20epic%20scale%2C%20cinematic%20widescreen%2C%20mystical%20atmosphere&width=1920&height=800&seq=movie-banner-012&orientation=landscape',
    isHot: false,
    isNew: true,
    updateInfo: '更新至第15集',
  },
];

export const getHotMovies = () => movies.filter((m) => m.isHot);
export const getNewMovies = () => movies.filter((m) => m.isNew);
export const getMovieById = (id: string) => movies.find((m) => m.id === id);
export const getMoviesByCategory = (category: string) =>
  movies.filter((m) => m.category === category);
export const getRelatedMovies = (movie: Movie, limit: number = 4) =>
  movies
    .filter((m) => m.id !== movie.id && m.category === movie.category)
    .slice(0, limit);